var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReferral(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 27C37 28.6575 35.6575 30 34 30C32.3425 30 31 28.6575 31 27C31 25.3425 32.3425 24 34 24C35.6575 24 37 25.3425 37 27Z",
    fill: "#616161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 25C32.8948 25 32 25.8948 32 27C32 28.1052 32.8948 29 34 29C35.1052 29 36 28.1052 36 27C36 25.8948 35.1052 25 34 25ZM30 27C30 24.7902 31.7902 23 34 23C36.2098 23 38 24.7902 38 27C38 29.2098 36.2098 31 34 31C31.7902 31 30 29.2098 30 27Z",
    fill: "#616161"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 37.3636C26 34.4618 31.33 33 34 33C36.67 33 42 34.4618 42 37.3636V42H26V37.3636Z",
    fill: "#616161"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2936 36.867C28.0106 37.1519 28 37.3082 28 37.3636V40H40V37.3636C40 37.3082 39.9894 37.1519 39.7064 36.867C39.4052 36.5637 38.9011 36.2325 38.2004 35.9263C36.788 35.3091 35.0608 35 34 35C32.9392 35 31.212 35.3091 29.7996 35.9263C29.0989 36.2325 28.5948 36.5637 28.2936 36.867ZM34 33C31.33 33 26 34.4618 26 37.3636V42H42V37.3636C42 34.4618 36.67 33 34 33Z",
    fill: "#616161"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 38C15 38.5369 15.1801 39.0412 15.4974 39.3981C15.7984 39.7367 16.2714 40 17 40H26.9996L26.9999 42H17C15.7286 42 14.7016 41.5133 14.0026 40.7269C13.3199 39.9588 13 38.9631 13 38V33.0006L15 33V38Z",
    fill: "#616161"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0001 30.5858L19.7072 36.2929L18.293 37.7071L14.0001 33.4142L9.70719 37.7071L8.29297 36.2929L14.0001 30.5858Z",
    fill: "#616161"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 8C11 6.89543 11.8954 6 13 6H21C22.1046 6 23 6.89543 23 8V9H28V28H6V9H11V8ZM11 11H8V13H11V11ZM11 15H8V26H13V20H21V26H26V15H23V16C23 17.1046 22.1046 18 21 18H13C11.8954 18 11 17.1046 11 16V15ZM23 13H26V11H23V13ZM19 26V22H15V26H19ZM16 11V8H18V11H21V13H18V16H16V13H13V11H16Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferral);
export default __webpack_public_path__ + "static/media/referral.4179ac5585a1db3325e0adf6ec9ab19b.svg";
export { ForwardRef as ReactComponent };